import { render, staticRenderFns } from "./Boundaries.vue?vue&type=template&id=2407819c&"
import script from "./Boundaries.vue?vue&type=script&lang=js&"
export * from "./Boundaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports